import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const projects = [
  "Indian Railway",
  "RRVUNL, Banswara",
  "Aksh Optifibre Ltd, Muhana Mandi, Jaipur",
  "SRF Ltd, Bhiwadi",
  "KEI Ltd, Bhiwadi",
  "Parle Candy, Neemrana",
  "Hero Motocorp.",
  "Honda Logistic",
  "TS Tech Sun",
  "Sanden Vikas Precision Parts Pvt. Ltd.",
  "Rajasthan Prime Steel Processing (RPSC)",
  "Rajasthan Patrika Pvt Ltd, Jaipur",
  "Bikanerwala, Jaipur center Developers, Jaipur",
  "Esspal International, Bhilwara",
  "Oasis Infotech & Test House, Jaipur",
  "Bhansali Urology & ENT Center, Bhilwara",
  "Geographics Interiors, Noida",
  "Ishita Orthopedic Hospital, Bhilwara",
  "Shri Khakhi Resort, BAR Pali",
  "ROSADO Lounge, Jaipur",
  "Nidec India Pvt. Ltd. (Neemrana)",
  "Tokai Rika Minda Pvt. Ltd. (TRMN)",
  "Gipskarton India Pvt. Ltd.",
  "Gosil Exports Pvt Ltd, Sitapura, Jaipur",
  "Havells India Ltd. (Ghiloth)",
  "SPR Takahata precision India pvt. ltd.",
  "Toyota Boshoku Device (Bawal)",
  "Suncity Projects, New Delhi",
  "Parle Biscuits Pvt. Ltd., Bahadurgarh/Rudrapur",
  "DD Pharmaceuticals Pvt. Ltd.",
  "Yes Bank Ltd (Multiple Branches)",
  "ICICI Bank Ltd (Multiple Branches)",
  "HDFC Bank Ltd (Multiple Branches)",
  "Lodha Hospital & Research Centre",
  "Flipkart Ltd, Mumbai",
  "Surya Foods",
  "Hotel Gadh Girvar, BARR, PALI",
  "Hotel Mulberry, Pushkar",
  "Suresh Gyan Vihar University, Jaipur",
];

const SuccessSlider = () => {
  return (
    <section className="container my-3">
      <div className="text-center mb-4">
        <h1 className="fw-bold" style={{ color: '#079000'}}>
          Loved by Customers
        </h1>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{ delay: 1000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {projects.map((name, index) => (
          <SwiperSlide key={index}>
            <div className="card shadow-sm text-center p-3 h-100">
              <h6 className="fw-semibold">{name}</h6>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default SuccessSlider;
